module.exports = __webpack_public_path__ + "img/consent_withdrawn.2e9b08f9.svg";